import React from 'react';

import classNames from 'classnames';

import { RDS_ICON } from '../Icon';

const SystemClose = React.forwardRef<
  HTMLSpanElement, // The reference type - which element the final ref is attached to.
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...spanProps }, forwardedRef) => {
  // System Icons are size 16 only
  const iconClasses = classNames(RDS_ICON, `${RDS_ICON}-16`, className);

  // Spans are used here for sizing the SVG and to keep in line with the current styles
  // TODO: explore decoupling the svg itself from the outer contents: https://jira.rallyhealth.com/browse/UCRON-1455
  return (
    <span ref={forwardedRef} {...spanProps} className={iconClasses}>
      <span>
        <svg
          focusable="false"
          height="16"
          role="presentation"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.721.326a.999.999 0 010 1.414L9.428 8.012l6.29 6.273a.999.999 0 11-1.414 1.414L8.013 9.424l-6.288 6.274c-.391.39-1.024.39-1.415-.001a.999.999 0 010-1.413l6.288-6.272L.31 1.741A.999.999 0 111.723.325L8.014 6.6 14.305.325a1.001 1.001 0 011.415.001z"
            fillRule="evenodd"
          />
        </svg>
      </span>
    </span>
  );
});

export default SystemClose;
